'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')
var BodyModel = require('src/common/page-model')

var ClientPresetsList = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      this.region = options.region

      var self = this

      var bodyModel = new BodyModel({
        title: 'Presets',
        buttons: []
      })

      // _.forEach(presets, function (preset) {
      //   PresetsCollection.add(preset)
      // })
      // PresetsCollection.add(presets)
      // console.log('presets')
      // console.log(presetsCollection)

      //
      // self.users = App.globalChannel.request('user:entities', {
      //   query: {
      //     client: options.client.get('_id')
      //   }
      // })

      self.layout = self.getLayoutView(bodyModel)

      self.listenTo(self.layout, 'render', function () {
        self.listRegion(self.devices)
      })
      // view events
      self.region.show(self.layout)
    },
    listRegion: function (nodes, columns) {
      var self = this

      var presets = self.options.client.get('presets')

      // init
      var Preset = Backbone.Model.extend({
        idAttribute: '_id'
      })

      var PresetsCollection = Backbone.Collection.extend({
        model: Preset
      })

      var presetsCollection = new PresetsCollection(presets)
      console.log(presetsCollection)
      //
      var columns = {
        '_bulk': {
          // 'options': {
          //   'edit': {'label': 'Edit','roles': ['super', 'admin']},
          //   'delete': {'label': 'Delete','roles': ['super']}
          // }
        },
        'name': {'label': 'name', 'sortable': true, 'roles': [] },
        'type': {'label': 'type', 'sortable': true, 'roles': []},
        'deviceType': {'label': 'device type', 'sortable': true, 'roles': []},
        '_actions': {
          'options': {
            'delete': { 'action': 'delete', 'roles': [] }
          }
        }
      }

      //
      var emptyViewModel = new Backbone.Model({
        title: 'No presets yet.'
      })

      //
      var layout = this.getListView(presetsCollection, columns, emptyViewModel)
      self.listenTo(layout, 'listview:childview:item:delete', self.onDelete)
      self.listenTo(layout, 'bulk:action', self.onBulk)

      self.layout.getRegion('listRegion').show(layout)
    },
    onDelete: function (args) {
      var self = this
      var presetCollection = args.collection
      var presetId = args.model.id
      console.log(presetId)

      self.options.client.removePreset(presetId, {
        silent: true,
        success: function () {
          args.model.collection.remove(args.model)
        }
      })
    },
    onEdit: function (args) {
      App.globalChannel.trigger('client-users:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.model})
    },
    // getLayoutView: function (presets) {
    //   return new ListView.layout({collection: presets})
    // }
    getListView: function (collection, columns, emptyViewModel) {
      // create the listview based on the list component
      return new View.listView({
        collection: collection,
        columns: columns,
        emptyViewModel: emptyViewModel,
        childView: View.listItem // use a custom childview
      })
    },
    getLayoutView: function (model) {
      return new View.layout({model: model})
    }
  })

  return new Controller(options)
}

module.exports = ClientPresetsList



// WEBPACK FOOTER //
// ./js/modules/client-presets/list/index.js